import { render, staticRenderFns } from "./UserNameRenderer.vue?vue&type=template&id=1a4e5513&"
import script from "./UserNameRenderer.vue?vue&type=script&lang=ts&"
export * from "./UserNameRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports